import React, { useEffect, useState } from 'react';
import { SOURCE_URL } from '../../../config';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface HomeNewSplitTemplateProps {
    element: any
}

const HomeNewSplitTemplate: React.FC<HomeNewSplitTemplateProps> = (element) => {
    const [sectionClass, setSectionClass] = useState<string>('');

    useEffect(()=>{
        if(element?.element){
            if(element?.element?.ShowIn == 'Desktop Only'){
                setSectionClass("d-lg-block d-none");
            }
            else if(element?.element?.ShowIn == 'Mobile Only'){
                setSectionClass("d-lg-none d-block");
            }
        }
    },[element?.element])
    

    const handleContent = (content: any[]) => {
        return Array.isArray(content) && content.map((item, index) => (
            <div key={index} className='col-lg-6 hid-overflow' style={{background: 'url('+SOURCE_URL + item?.BackgroundImage?.data?.attributes?.url+') '+item?.BackgroundImagePosition?.replace(" - ", " ").toLowerCase()+' / cover'}}>
			    <div className='h-100 d-flex justify-content-between flex-column'>
                    <style>{`#main .arrowed-link:hover{color: #F37D16 !important}`}</style>
                    <div className={`pt-5 ${item?.TextColor?.toLowerCase()} pxc`} style={{zIndex:2}}>
                        <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{item?.FeaturedText}</ReactMarkdown>
                        {item?.ChannelLogo?.data?.attributes?.url ?
                        <img src={SOURCE_URL + item?.ChannelLogo?.data?.attributes?.url} className='channel-logo mb-4 d-block' />
                        :<></>}
                        <div style={{marginBottom: '-1.5rem'}}>
                            {item?.ButtonURL ? 
                            <a href={item?.ButtonURL} id={item?.ButtonID} className={'default-btn d-inline-block mb-4 '+ (item?.AddOnLinkURL ? "mr-4" : "")} target={item?.OpenButtonLinkInANewTab ? '_blank' : '_self'}>{item?.ButtonLinkText}</a>
                            :<></>}
                            {item?.AddOnLinkURL ? 
                            <a href={item?.AddOnLinkURL} className='arrowed-link d-inline-block mb-4 add-on-link' target={item?.OpenAddOnLinkInANewTab ? '_blank' : '_self'}>{item?.AddOnLinkText}<i className="icon-angle-right"></i></a>
                            :<></>}
                        </div>
                    </div>
                    <img src={SOURCE_URL + item?.BottomImage?.data?.attributes?.url} className='w-100 d-block bottom-img'/>
                </div>
            </div>
        ));
    }

    return (
      <>
        <section className={"split-template " + sectionClass}>
            <div className="row no-gutters">
                {handleContent(element?.element?.SplitTemplateContent)}
            </div>
        </section>
      </>
    );
};

export default HomeNewSplitTemplate;